// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__V7k1N","logo":"Loading_logo__oMi4k","rotate":"Loading_rotate__nTkJ0","logoImage":"Loading_logoImage__YfYap","fadeIn":"Loading_fadeIn__+fg2P"};